var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row margin-bottom-large",class:{ wrapper: _vm.assessment }},[_c('div',{staticClass:"large-12 columns padding-top-medium"},[_c('article-ebook',{attrs:{"article":_vm.article}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }